<template>
  <div :class="`${$style.date} ${error ? $style.error : ''}`" :title="error">
    {{ dateString }}
  </div>
</template>

<script>
import Vue from "vue";
import moment from "moment";

export default Vue.extend({
  data() {
    return {
      value: "",
      error: undefined,
    };
  },

  methods: {
    refresh(params) {
      const { value, valueFormatted } = params;
      const { error } = valueFormatted || {};
      this.value = value;
      this.error = error;
    },
  },
  computed: {
    dateString() {
      if (this.value === undefined || this.value === null) {
        return "";
      }
      const d = moment(this.value);
      return d.isValid() ? d.toDate().toLocaleDateString() : "";
    },
  },
  created() {
    const { value, valueFormatted } = this.params;
    const { error } = valueFormatted || {};
    this.value = value;
    this.error = error;
  },
});
</script>

<style lang="scss" module>
.date {
  width: 100%;
  height: 100%;

  &.error {
    background-color: #e57373;
  }
}
</style>
